// src/modules/Rules/adapters/PacksApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';
import type { Option } from './ConditionApiAdapter';

export class PacksApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<Option[]> {
    const raw = await this.httpClient.get<any>('/packs');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((p: any) => ({
      id: String(p.id),
      name: p.title,
    }));
  }
}
